<template>
  <div class="container">
    <div class="baojing_main">
      <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="no"
        :src="iframeUrl"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      iframeUrl: ''
    }
  },
  mounted() {
    let url =process.env.VUE_APP_BASE_API
    if(url==='https://light.taiott.com') {
      this.iframeUrl='../../../static/baojing/alarmWeb.html?company=thwl&username='+this.$store.state.user.name+'&token='+this.$store.state.user.token
    }else{
      this.iframeUrl='../../../static/baojing/alarmWeb.html?username='+this.$store.state.user.name+'&token='+this.$store.state.user.token
    }
  }
}
</script>
<style scoped>
.container {
  position: relative;
	width: 100%;
	height:100%;
	background:url('../../assets/datacount.png') no-repeat;
	background-size: cover;
}
.baojing_main{
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  overflow: hidden;
}

#iframeContain{
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin:0;
}
</style>